import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { DefaultReportTemplate } from '../models/DefaultReportTemplate';
import { DefaultReportTemplateSearchCriteria } from '../models/searchCriteria/DefaultReportTemplateSearchCriteria';

@Injectable({
  providedIn: 'root'
})
export class DefaultReportTemplateService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: DefaultReportTemplateSearchCriteria): Observable<PagedData<DefaultReportTemplate>> {
    return this.httpClient.post<PagedData<DefaultReportTemplate>>(environment.apiUrl + "default-report-templates/filtered", searchCriteria);
  }

  get(type: string): Observable<DefaultReportTemplate> {
    return this.httpClient.get<DefaultReportTemplate>(environment.apiUrl + "default-report-templates/" + type);
  }

  create(defaultReportTemplate: DefaultReportTemplate): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "default-report-templates", defaultReportTemplate);
  }

  update(type: string, defaultReportTemplate: DefaultReportTemplate): Observable<void> {
    return this.httpClient.put<void>(environment.apiUrl + "default-report-templates/" + type, defaultReportTemplate);
  }

}
